import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../../ng2-bootstrap-modal/dialog.service';
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {HostingService} from "../../hosting.service";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {Utils} from "../../../../../shared/utils/utils";
import { filter, first } from "rxjs";

export interface IPhpVersionData {
  websiteId: number;
  phpVersion: string;
}
@Component({
    selector: 'db-change-php-engine',
    templateUrl: './change-php-engine.component.html',
    styleUrls: ['./change-php-engine.component.scss'],
    standalone: false
})
export class ChangePhpEngineComponent extends DialogComponent<IPhpVersionData, Boolean> implements OnInit, IPhpVersionData {

  @Input() websiteId: number;
  @Input() phpVersion: string;

  public changes: any;
  public loading: boolean;
  public isMobile: boolean;

  constructor(
    private _dialogService: DialogService,
    private _hostingService: HostingService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }

  public changePHPversion(): void {
    this.loading = true;
    this._hostingService.changePhpVersion( this.websiteId, this.phpVersion )
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          const installing = response.data && response.data.installing && Utils.isTruthy(response.data.installing);
          !!installing && localStorage.setItem('changedPhpVersion' + this.websiteId, (new Date().getTime()).toString());
          this.confirm(!!installing ? 'disable' : 'enable');
          NotifierComponent.notify(new Notification("PHP version changed successfully", NotificationType.SUCCESS));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.loading = false;
      });
  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

  public confirm(installing: any): void {
    this.result = installing;
    this.close();
  }

}
